import React from "react";
import { useTranslation } from "react-i18next";
import { CiCircleCheck } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import routes from "../../../routes/routes";
import { bookingCreationCompleted } from "../../../redux/slice/bookingCreation/bookingCreationSlice";
import { useDispatch } from "react-redux";

const SuccessStep = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleContactSupport = () => {
    dispatch(bookingCreationCompleted());
    navigate("/hints/page/HelpAccordionList");
  };

  const handleNavigateToOrders = () => {
    dispatch(bookingCreationCompleted());
    navigate(routes.orders);
  };

  return (
    <div className="flex flex-col w-full h-full">
      {/* Main content - centered */}
      <div className="flex flex-col items-center justify-center flex-1">
        <CiCircleCheck className="size-[135px] text-primary" />

        <div className="max-w-md mx-auto mb-5 mt-6 text-center p-4">
          <p className="text-foreground text-base leading-relaxed mb-5">
            {t(
              "book_location.success.message",
              "You have successfully reserved a locker for your parcel delivery. Kindly check your email for the details to share with the delivery agency. You can preview your booking "
            )}
            <button type="button" onClick={handleNavigateToOrders} className="inline appearance-none p-0 align-baseline text-primary underline underline-offset-2 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-sm">
              {t("book_location.success.here", "here")}
            </button>
            {t("book_location.success.see", "see")}
            .
          </p>
        </div>
      </div>

      {/* Bottom section */}
      <div className="mt-auto pb-8 text-center">
        <p className="text-sm text-foreground">
          {t("book_location.success.trouble", "Having trouble? ")}
          <button
            type="button"
            className="inline appearance-none p-0 align-baseline text-primary underline underline-offset-2 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-sm"
            onClick={handleContactSupport}
          >
            {t("book_location.success.contact_support", "Contact support")}
          </button>
        </p>
      </div>
    </div>
  );
};

export default SuccessStep;
